export const FORM_NAMES = {
  UPDATE_DATA: 'updateData-form',
};
